"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __exportStar = this && this.__exportStar || function (m, exports) {
  for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NotificationsGraphQLService = exports.notificationsGraphQLService = exports.DigestGraphQLService = exports.digestGraphQLService = exports.RegistrationGraphQLService = exports.registrationGraphQLService = exports.MeService = exports.meService = exports.removeTypeNameFieldFromResponse = exports.BaseGraphQLService = void 0;
var BaseGraphQLService_1 = require("./BaseGraphQLService");
Object.defineProperty(exports, "BaseGraphQLService", {
  enumerable: true,
  get: function () {
    return __importDefault(BaseGraphQLService_1).default;
  }
});
Object.defineProperty(exports, "removeTypeNameFieldFromResponse", {
  enumerable: true,
  get: function () {
    return BaseGraphQLService_1.removeTypeNameFieldFromResponse;
  }
});
var MeService_1 = require("./me/MeService");
Object.defineProperty(exports, "meService", {
  enumerable: true,
  get: function () {
    return __importDefault(MeService_1).default;
  }
});
Object.defineProperty(exports, "MeService", {
  enumerable: true,
  get: function () {
    return MeService_1.MeService;
  }
});
var RegistrationGraphQLService_1 = require("./registration/RegistrationGraphQLService");
Object.defineProperty(exports, "registrationGraphQLService", {
  enumerable: true,
  get: function () {
    return __importDefault(RegistrationGraphQLService_1).default;
  }
});
Object.defineProperty(exports, "RegistrationGraphQLService", {
  enumerable: true,
  get: function () {
    return RegistrationGraphQLService_1.RegistrationGraphQLService;
  }
});
__exportStar(require("./users"), exports);
var DigestService_1 = require("./digest/DigestService");
Object.defineProperty(exports, "digestGraphQLService", {
  enumerable: true,
  get: function () {
    return __importDefault(DigestService_1).default;
  }
});
Object.defineProperty(exports, "DigestGraphQLService", {
  enumerable: true,
  get: function () {
    return DigestService_1.DigestGraphQLService;
  }
});
var NotificationsGraphQLService_1 = require("./notifications/NotificationsGraphQLService");
Object.defineProperty(exports, "notificationsGraphQLService", {
  enumerable: true,
  get: function () {
    return __importDefault(NotificationsGraphQLService_1).default;
  }
});
Object.defineProperty(exports, "NotificationsGraphQLService", {
  enumerable: true,
  get: function () {
    return NotificationsGraphQLService_1.NotificationsGraphQLService;
  }
});
__exportStar(require("./me/mutations"), exports);
__exportStar(require("./me/queries"), exports);
__exportStar(require("./documents"), exports);
__exportStar(require("./notifications/queries"), exports);
__exportStar(require("./registry"), exports);
__exportStar(require("./polls"), exports);
__exportStar(require("./meeting"), exports);
__exportStar(require("./tariffs"), exports);
__exportStar(require("./payments"), exports);
__exportStar(require("./pretensions"), exports);
__exportStar(require("./petitions"), exports);
__exportStar(require("./signing"), exports);
__exportStar(require("./callCenter"), exports);
__exportStar(require("./hoa"), exports);
__exportStar(require("./usefulAddress"), exports);
__exportStar(require("./documentsPage"), exports);